<template>
    <v-responsive max-width="1024px" width="100%" height="100%" class="mx-auto overflow-visible">
        <div class="headline text-start mt-8">
            <span v-if="application._id">법률 정보 제공 수정</span>
            <span v-else>법률 정보 제공 등록</span>
        </div>

        <section class="mt-4">

            <v-card>
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">제목</v-col>
                        <v-col cols="10">
                            <v-text-field v-model="application.subject" dense outlined hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">작성일</v-col>
                        <v-col cols="10">
                            <v-text-field :value="$dayjs(application.createdAt).format('YYYY-MM-DD HH:mm:ss')" type="datetime-local" dense outlined hide-details @change="value => application.createdAt = $dayjs(value).toDate()" />
                            <div class="text-caption primary--text">* 작성일이 최신일수록 상단에 노출됩니다</div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </section>

        <section class="mt-4">
            <v-layout>
                <span class="subtitle-2 font-weight-bold">첨부파일</span>
            </v-layout>
            <v-card>
                <v-card-text class="d-flex">
                    <v-spacer/>
                    <v-btn small color="primary" @click="$refs.files.$el.getElementsByTagName('input')[0].click()"><v-icon left size="18">mdi-plus</v-icon>추가</v-btn>
                    <v-file-input v-model="files" ref="files" multiple accept=".pdf, .xls, .xlsx" class="d-none" @change="upload(Array.isArray(files) ? files : [files]).then(res => $set(application, 'files', [...(application.files || []), ...res]))"/>
                </v-card-text>
                <template v-for="item, index in application.files">
                    <v-divider :key="'divider' + index"/>
                    <v-row :key="index" align="center" class="px-4">
                        <v-col>
                            <v-btn color="blue" outlined @click="download(item.src, item.name)">{{ item.name }}<v-icon size="16" right>mdi-download</v-icon></v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn small outlined color="red" @click="application.files.splice(index, 1)"><v-icon size="18">mdi-delete-outline</v-icon>삭제</v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-card>
        </section>

        <section class="mt-4">
            <v-layout>
                <span class="subtitle-2 font-weight-bold">상세내용</span>
            </v-layout>
            <v-card>
                <v-card-text>
                    <naver-smarteditor v-model="application.content" />
                </v-card-text>
            </v-card>
        </section>

        <v-row justify="center" class="mx-1 my-4">
            <v-col md="auto" sm="auto">
                <v-btn dark color="blue darken-1" @click="save()">저장</v-btn>
            </v-col>
        </v-row>
    </v-responsive>
</template>

<script>
import api from "@/api";
import NaverSmarteditor from '@/components/plugins/naver/naver-smarteditor.vue';
import download from "downloadjs";

export default {
    components: {
        NaverSmarteditor
    },
    data() {
        return {
            application: {
                _id: this.$route.params._id || null,

                subject: null,
                content: null,

                files: [],

                createdAt: undefined,
            },

            files: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        download: (url, name) => api.resource.get(url).then(file => download(file, name)),
        async init() {
            if (this.application._id) {
                let { application } = await api.console.legal.applications.get({ _id: this.application._id });
                this.application = application;
            }
        },

        async upload(files){
            if(!Array.isArray(files)) return await api.resource.post(files, "/res/legal/applications");

            let _ = [];
            for(let file of files){
                _.push(await api.resource.post(file, "/res/legal/applications"));
            }

            return _;
        },

        validate(){
            try{
                if(!this.application.subject) throw new Error("제목을 작성해주세요");
                if(!this.application.content) throw new Error("상세내용을 작성해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                await api.console.legal.applications[this.application._id ? "put" : "post"](this.application);

                alert("저장되었습니다");
                this.$router.push(`/console/legal/applications`);
            }
        },
    },
};
</script>
